<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getErrorLogs.length > 0 && $store.getters.getErrorLogsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'forbiddenKeywords_Id',
            'forbiddenKeywords_ForbiddenGoodsKeyword',
            'forbiddenKeywords_Status',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th></th>
            <th>{{ $t('errorLogs_Id.localization_value.value') }}</th>
            <th>{{ $t('errorLogs_createdAt.localization_value.value') }}</th>
            <th>{{ $t('errorLogs_path.localization_value.value') }}</th>
            <th>{{ $t('errorLogs_traceLine.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getErrorLogs" :key="index">
            <td>
              <DefaultCheckbox
                  class="empty-label"
                  :selectedNow="selectedNow"
                  :dataValue="item.id"
              />
            </td>
            <td>
              #{{item.id}}
            </td>
            <td>
              {{ item.created_at | moment("DD MMM, YYYY") }}
            </td>
            <td>
<!--              <TooltipTextHelper-->
<!--                  :fullTextWidth="'300'"-->
<!--                  :text="item['route_path']"-->
<!--                  :paragraph="item['route_path']"-->
<!--                  :styleClass="'white-space-normal style-ellipsis'"-->
<!--              />-->
              {{ item.route_path }}
            </td>
            <td>
<!--              <TooltipTextHelper-->
<!--                  :fullTextWidth="'450'"-->
<!--                  :text="item['trace_line'].substring(0, 150)"-->
<!--                  :paragraph="item['trace_line'].substring(0, 250)"-->
<!--                  :styleClass="'white-space-normal style-ellipsis'"-->
<!--              />-->
              {{ item['trace_line'].substring(0, 150) }}
            </td>
            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_detail.localization_value.value')"
                            :type="'edit'"
                            :link="$store.getters.GET_PATHS.errorLogs + '/show/' + item.id"
                            :target="'_blank'"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getErrorLogs"
                 :key="index"
            >
              <ErrorLogsTableMobile
                      :item="item"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getErrorLogsCommonList.next_page_url !== null && $store.getters.getErrorLogs.length > 0"
                    @click.native="$emit('showMore')"
                    v-bind:class="{'disabled-btn' : $store.getters.getNextErrorLogsPage}"
                    :count="$store.getters.getErrorLogsCommonList.total - $store.getters.getErrorLogsForPage * $store.getters.getErrorLogsCommonList.current_page < $store.getters.getErrorLogsForPage ?
                    $store.getters.getErrorLogsCommonList.total - $store.getters.getErrorLogsForPage * $store.getters.getErrorLogsCommonList.current_page:
                    $store.getters.getErrorLogsForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getErrorLogsLoading === false && $store.getters.getErrorLogs.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

  </div>
</template>

<script>
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import ErrorLogsTableMobile from "./ErrorLogsTableMobile/ErrorLogsTableMobile";
  import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
  // import TooltipTextHelper from "@/components/coreComponents/TooltipTextHelper/TooltipTextHelper";

  export default {
    name: "ErrorLogsTable",
    components: {
      // TooltipTextHelper,
      DefaultCheckbox,
      ErrorLogsTableMobile,
      NoResult,
      ManagerButton,
      LinkButton,
      ShowMore,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
      selectedNow: Boolean,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalErrorLogsPopup: false,

      }
    },

    methods: {
      changeErrorLogsPopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalErrorLogsPopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteErrorLogs', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
